const GROWTH_FIELDS = ['rent_growth_yoy', 'rent_growth_qoq', 'comeff_rent_yoy', 'comeff_rent_qoq'];

// The API transports fractional rates. Convert once at the chart/export input.
export function normalizeOperationGrowthRows(rows = []) {
  return rows.map(row => {
    const result = { ...row };
    GROWTH_FIELDS.forEach(field => {
      const value = row[field];
      result[field] = value == null || String(value).trim() === '' || !Number.isFinite(Number(value))
        ? null : Number(value) * 100;
    });
    return result;
  });
}

export function formatOperationGrowth(value) {
  return value == null || String(value).trim() === '' || !Number.isFinite(Number(value))
    ? '' : `${Number(value).toFixed(2)}%`;
}
